/**
 * ![pink 50](https://mui.com/static/colors-preview/pink-50-24x24.png) ![pink 100](https://mui.com/static/colors-preview/pink-100-24x24.png) ![pink 200](https://mui.com/static/colors-preview/pink-200-24x24.png) ![pink 300](https://mui.com/static/colors-preview/pink-300-24x24.png) ![pink 400](https://mui.com/static/colors-preview/pink-400-24x24.png) ![pink 500](https://mui.com/static/colors-preview/pink-500-24x24.png) ![pink 600](https://mui.com/static/colors-preview/pink-600-24x24.png) ![pink 700](https://mui.com/static/colors-preview/pink-700-24x24.png) ![pink 800](https://mui.com/static/colors-preview/pink-800-24x24.png) ![pink 900](https://mui.com/static/colors-preview/pink-900-24x24.png) ![pink A100](https://mui.com/static/colors-preview/pink-A100-24x24.png) ![pink A200](https://mui.com/static/colors-preview/pink-A200-24x24.png) ![pink A400](https://mui.com/static/colors-preview/pink-A400-24x24.png) ![pink A700](https://mui.com/static/colors-preview/pink-A700-24x24.png)
 */
const pink = {
  /**
   * Preview: ![pink 50](https://mui.com/static/colors-preview/pink-50-24x24.png)
   */
  50: '#fce4ec',
  /**
   * Preview: ![pink 100](https://mui.com/static/colors-preview/pink-100-24x24.png)
   */
  100: '#f8bbd0',
  /**
   * Preview: ![pink 200](https://mui.com/static/colors-preview/pink-200-24x24.png)
   */
  200: '#f48fb1',
  /**
   * Preview: ![pink 300](https://mui.com/static/colors-preview/pink-300-24x24.png)
   */
  300: '#f06292',
  /**
   * Preview: ![pink 400](https://mui.com/static/colors-preview/pink-400-24x24.png)
   */
  400: '#ec407a',
  /**
   * Preview: ![pink 500](https://mui.com/static/colors-preview/pink-500-24x24.png)
   */
  500: '#e91e63',
  /**
   * Preview: ![pink 600](https://mui.com/static/colors-preview/pink-600-24x24.png)
   */
  600: '#d81b60',
  /**
   * Preview: ![pink 700](https://mui.com/static/colors-preview/pink-700-24x24.png)
   */
  700: '#c2185b',
  /**
   * Preview: ![pink 800](https://mui.com/static/colors-preview/pink-800-24x24.png)
   */
  800: '#ad1457',
  /**
   * Preview: ![pink 900](https://mui.com/static/colors-preview/pink-900-24x24.png)
   */
  900: '#880e4f',
  /**
   * Preview: ![pink A100](https://mui.com/static/colors-preview/pink-A100-24x24.png)
   */
  A100: '#ff80ab',
  /**
   * Preview: ![pink A200](https://mui.com/static/colors-preview/pink-A200-24x24.png)
   */
  A200: '#ff4081',
  /**
   * Preview: ![pink A400](https://mui.com/static/colors-preview/pink-A400-24x24.png)
   */
  A400: '#f50057',
  /**
   * Preview: ![pink A700](https://mui.com/static/colors-preview/pink-A700-24x24.png)
   */
  A700: '#c51162',
} as const;

export default pink;
